<template>
  <confirm-dialog ref="confirm"></confirm-dialog>
  <div class="card bg-light">
    <div class="card-header">
      Advanced Search
      <span class="float-end sticky-top" style="cursor: pointer" @click="close()">
        <font-awesome-icon icon="xmark" />
      </span>
      <div class="row">
        <div class="col-12">
          <smart-button
            class-override="btn-outline-secondary"
            class="mt-2"
            :disabled="false"
            :loading="loading"
            :click="handleExportTrades"
            >Export Results
          </smart-button>
        </div>
      </div>
    </div>
    <div class="card-body">
      <smart-input
        id="tradeCode"
        v-model="model.tradeCode"
        label="Trade Code"
        :is-required="false"
      />
      <smart-select-key-value
        id="active"
        v-model="model.active"
        label="Active"
        :is-required="false"
        :options="binaryOptions"
      />
      <smart-input id="standard" v-model="model.standard" label="Standard" :is-required="false" />
      <smart-input
        id="pasAnnexAdvanced"
        v-model="model.pasAnnexAdvanced"
        label="PAS Annex"
        :is-required="false"
      />
      <smart-textarea
        id="tradeSkills"
        v-model="model.tradeSkills"
        label="Trade Skills (separate with commas)"
        :is-required="false"
      />

      <smart-textarea
        id="searchKeywords"
        v-model="model.searchKeywords"
        label="Search Keywords (separate with commas)"
        :is-required="false"
      />

      <div class="row">
        <div class="col-6">
          <smart-button
            class-override="btn-outline-secondary"
            :disabled="false"
            :loading="false"
            :click="reset"
            >Reset
          </smart-button>
        </div>
        <div class="col-6">
          <smart-submit
            :small="true"
            :disabled="false"
            :loading="loading"
            :click="advancedSearch"
            label="Apply"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  SmartInput,
  SmartSubmit,
  SmartButton,
  SmartSelectKeyValue,
  SmartTextarea,
  ConfirmDialog,
  confirmType,
} from '@trustmark-2005-ltd/trustmark-shared-components';


export default {
  name: 'TradesAdvancedSearch',
  components: {
    SmartButton,
    SmartSubmit,
    SmartInput,
    SmartSelectKeyValue,
    SmartTextarea,
    ConfirmDialog,
  },
  emits: ['reset-requested', 'close', 'search', 'export-trades'],
  data() {
    return {
      loading: false,
      model: {
        tradeCode: null,
        active: null,
        standard: null,
        pasAnnexAdvanced: null,
        tradeSkills: null,
        searchKeywords: null,
      },
      binaryOptions: [
        { key: true, value: 'Yes' },
        { key: false, value: 'No' },
      ],
    };
  },

  methods: {
    advancedSearch() {
      this.$emit('search', { ...this.model });
    },
    handleExportTrades() {
      this.$refs.confirm
        .show({
          title: 'Export Results',
          message: `Are you sure you want to export the results?`,
          confirmType: confirmType.standard,
          okButtonText: 'Export Results',
        })
        .then(() => {
          this.$emit('export-trades');
        });
    },
    reset() {
      this.$emit('reset-requested', null);
      this.model = {
        tradeCode: null,
        active: null,
        standard: null,
        pasAnnexAdvanced: null,
        tradeSkills: null,
        searchKeywords: null,
      };
    },
    close() {
      this.$emit('close', null);
    },
  },
};
</script>
